export const addZeroToOneDecimal = (number) => {    
   var stringNumber = '' + number;
   var decimal = stringNumber.split('.')[1];
   if(decimal != undefined && decimal.length === 1)
    stringNumber += '0';
   return(stringNumber);
};
